import React from "react";
import { Button, Tag } from "antd";
import { LoginOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { getShareScopeLabel } from "../../../../Utils/shareScope";
import styles from "./RouteCard.module.scss";

// Ilustracion generica de itinerario (no hay banner por ruta).
const ROUTE_ILLUSTRATION =
  "https://storage.googleapis.com/educa360-legacy-assets/legacy/repopublic-educa360-central/adminweb/virtualscenes/PubliEduca360/Itinerario/1754473963925_itinerarioB.jpg";

/**
 * RouteCard — card de itinerario (Itinerarios, F4).
 * Portada + nombre + "Asignado a {clase}" + Entrar + badge shareScope.
 */
export function RouteCard({ route, selected, onEnter }) {
  const { t } = useTranslation("evaluations");
  return (
    <div className={`${styles.card} ${selected ? styles.selected : ""}`}>
      <div className={styles.cover}>
        <img src={ROUTE_ILLUSTRATION} alt="" loading="lazy" />
        <Tag className={styles.badge}>{getShareScopeLabel(route)}</Tag>
      </div>
      <div className={styles.name} title={route.nameRute}>
        {route.nameRute}
      </div>
      <div className={styles.assigned}>
        {t("rutasPanel.assignedTo")}{" "}
        {route.classnumber || t("rutasPanel.noClass")}
      </div>
      <Button
        type="primary"
        size="small"
        icon={<LoginOutlined />}
        className={styles.enter}
        onClick={() => onEnter?.(route)}
      >
        {t("rutasPanel.enterButton")}
      </Button>
    </div>
  );
}

export default RouteCard;
